/* unplugin-vue-components disabled */import { render } from "./cooperation.vue?vue&type=template&id=1824f2b2&scoped=true&ts=true"
import script from "./cooperation.vue?vue&type=script&lang=ts"
export * from "./cooperation.vue?vue&type=script&lang=ts"

import "./cooperation.vue?vue&type=style&index=0&id=1824f2b2&lang=less&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/yunxiaobao-test/prod-huodada-com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1824f2b2"]])

export default __exports__